import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import postscribe from 'postscribe';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { onlineConsultantScript } from './app/shared/analytics/onlineConsultant/onlineConsultantScript';
import { initSentry, setClientConfigs } from './tools';
import { init } from '@module-federation/enhanced/runtime';
import { appConfig } from '@pflm-shared';
import { RetryPlugin } from '@module-federation/retry-plugin';

setClientConfigs();

if (environment.production) {
  enableProdMode();
}

if (environment.analytics && environment.enableOnlineConsultant) {
  if (
    !location.pathname.includes('bvb') &&
    !location.href.includes('saas') &&
    !location.origin.includes('kruzhki') &&
    !location.origin.includes('mosreg')
  ) {
    postscribe('#head', onlineConsultantScript);
  }
}

initSentry();

init({
  name: 'pflm_host',
  remotes: [
    {
      name: 'pflm_b2gnew',
      entry: appConfig.B2GNEW_REMOTE_ENTRY,
    },
    {
      name: 'pflm_loginandregistration',
      entry: appConfig.LOGIN_AND_REGISTRATION_REMOTE_ENTRY,
    },
    {
      name: 'pflm_lessons',
      entry: appConfig.LESSONS_REMOTE_ENTRY,
    },
    {
      name: 'pflm_survey',
      entry: appConfig.SURVEY_REMOTE_ENTRY,
    },
    {
      name: 'pflm_results',
      entry: appConfig.RESULTS_REMOTE_ENTRY,
    },
    {
      name: 'pflm_professions',
      entry: appConfig.PROFESSIONS_REMOTE_ENTRY,
    },
    {
      name: 'pflm_userexperience',
      entry: appConfig.USER_EXPERIENCE_REMOTE_ENTRY,
    },
  ],
  plugins: [
    RetryPlugin({
      fetch: {
        retryTimes: 5,
        retryDelay: 1000,
      },
      script: {
        retryTimes: 5,
        retryDelay: 1000,
        cb: (resolve, error) => {
          return setTimeout(() => {
            resolve(error);
          }, 1000);
        },
      },
    }),
  ],
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
